import { render, staticRenderFns } from "./savings_subscribe_record.vue?vue&type=template&id=2f05df40&scoped=true"
import script from "./savings_subscribe_record.vue?vue&type=script&lang=js"
export * from "./savings_subscribe_record.vue?vue&type=script&lang=js"
import style0 from "./savings_subscribe_record.vue?vue&type=style&index=0&id=2f05df40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f05df40",
  null
  
)

export default component.exports